import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { serializeStockReturnUpdate } from '#/api/imsMgmt/receipts/stockReturn/serializeStockReturnWrite';
import { omitTopLevelId } from '#/api/adapters/patchBody';

/** PATCH `/ims/stock-return/{id}`。僅 DRAFT。 */
export async function updateStockReturn(id, values) {
  const { data: raw } = await request.patch(
    `/ims/stock-return/${id}`,
    serializeStockReturnUpdate(omitTopLevelId(values)),
  );
  return parseVer4DetailResponse(raw);
}
